import styled from "styled-components";
import HelpIcon from "@mui/icons-material/Help";

interface IRowInput {
	pendingToMap?: boolean;
}
export const RowInput = styled.div<IRowInput>`
	display: grid;
	grid-template-columns: ${(prop) => (prop.pendingToMap ? "2fr 2fr 2fr 2fr 0fr" : "1fr 1fr 1fr 1fr")};
	align-items: flex-start;
	gap: 10px;

	@media (max-width: 426px) {
		grid-template-columns: 1fr;

		button {
			width: 100%;
			max-width: 100%;
			padding: 0.4rem 0 !important;
			margin: 0;
		}
	}
`;

export const HelperIconContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	color: ${({ theme }) => theme.pantone2726C};
	font-weight: bold;
`;

export const IconHelp = styled(HelpIcon)`
	&&& {
		cursor: pointer;
		font-size: 32px;
		color: ${({ theme }) => theme.pantone2726C};
	}
`;
